import Dialog from '@corvu/dialog'
import { m } from '~/paraglide/messages'

/**
 * The generic failure dialog of the claim/redeem error ladder — shown when a
 * write failed for a reason refetching cannot correct (network, 5xx).
 */
export function ConnectionIssueDialog(props: {
  open: boolean
  onClose: () => void
}) {
  return (
    <Dialog
      role="alertdialog"
      open={props.open}
      onOpenChange={(open) => {
        if (!open) props.onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay class="fixed inset-0 z-40 bg-black/10 backdrop-blur-[12.5px] ease-out data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0" />
        <Dialog.Content
          // Same white/80 + blur(50) material and 2px gradient inner stroke
          // as the enter-code sheet's confirm dialog (Figma 470:36630).
          class="gradient-outline fixed inset-0 z-40 m-auto flex h-fit w-[300px] flex-col gap-6 rounded-[32px] bg-white/80 p-6 backdrop-blur-[50px] ease-out data-[open]:animate-in data-[closed]:animate-out data-[closed]:fade-out-0 data-[open]:fade-in-0 data-[closed]:zoom-out-95 data-[open]:zoom-in-95"
          style={{ '--ow': '2px' }}
        >
          <div class="flex flex-col gap-2 text-center">
            <Dialog.Label class="text-lg font-semibold leading-[26px] text-[#333]">
              {m.dialog_connection_issue_title()}
            </Dialog.Label>
            <Dialog.Description class="text-base leading-[22px] text-[#666]">
              {m.dialog_connection_issue_description()}
            </Dialog.Description>
          </div>
          <button
            type="button"
            onClick={() => props.onClose()}
            class="flex h-[52px] items-center justify-center rounded-full bg-cta text-base font-bold leading-5 text-white shadow-[0_0_20px_-2px_rgba(198,255,205,0.15)] transition-colors duration-150 active:bg-cta-press"
          >
            {m.ok()}
          </button>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog>
  )
}
